// 退回记录
import { Card, Empty, Row, Col } from 'antd'
import moment from 'moment'
import { formatEmnOfSign } from '@/services/homeService'
import dayjs from "dayjs";
export const BackLog = (props: any) => {
  const { detailsInfo } = props
  const backResult = [
    { code: 1, label: '责任归属错误' },
    { code: 2, label: '其他' },
  ]
  return detailsInfo?.backDate ||
    detailsInfo?.backClassifyId ||
    detailsInfo?.backDescription ||
    detailsInfo?.backUser ? (
    <Card
      key={'BackLog'}
      headStyle={{ padding: '0 12px' }}
      bodyStyle={{
        padding: '8px 10px',
        backgroundColor: '#FAFAFA',
        borderTop: '1px solid #f0f0f0',
      }}
      style={{ marginBottom: 12 }}
      title={detailsInfo.backDate ? dayjs(detailsInfo.backDate).format('YYYY-MM-DD HH:mm:ss') : ''}
      extra={<div>操作类型 :{detailsInfo?.type || ' 退回记录'}</div>}
    >
      <Row>
        <Col span={4}>退回分类：</Col>
        <Col span={20}>{formatEmnOfSign(detailsInfo.backClassifyId, backResult)}</Col>
      </Row>
      <Row>
        <Col span={4}>退回原因：</Col>
        <Col span={20}>{detailsInfo.backDescription}</Col>
      </Row>
      <Row>
        <Col span={4}>退回人：</Col>
        <Col span={20}>{detailsInfo.backUserName}</Col>
      </Row>
    </Card>
  ) : (
    <Empty />
  )
}
